if (!customElements.get('miramar-customization')) {
  customElements.define('miramar-customization', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.ids = this.dataset.customIds.split(',').filter(Boolean);
      this.variantInput = this.form.querySelector('[name="id"]');
      this.fields = this.querySelector('fieldset');
      this.word = this.querySelector('[name="properties[Palabra o frase]"]');
      this.color = this.querySelector('[name="properties[Color principal]"]');
      this.onChange = () => this.sync();
      this.onInput = () => this.updateSummary();
      this.variantInput.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('change', this.onInput);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId === this.form.closest('product-form').dataset.sectionId) this.sync();
      });
      this.sync();
    }
    disconnectedCallback() {
      if (this.variantInput) this.variantInput.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('change', this.onInput);
      if (this.unsubscribe) this.unsubscribe();
    }
    sync() {
      this.active = this.ids.includes(this.variantInput.value);
      if (this.fields) {
        this.fields.hidden = !this.active;
        const pickup = this.form.closest('section').querySelector('pickup-availability');
        if (pickup) pickup.hidden = this.active;
        this.fields.querySelectorAll('input,select').forEach(input => { input.disabled = !this.active; });
      } else {
        this.querySelector('[data-consultation-notice]').hidden = !this.active;
        const payment = this.form.querySelector('.shopify-payment-button');
        if (payment) payment.hidden = this.active;
        const button = this.form.querySelector('[name="add"]');
        if (this.active && button) button.disabled = true;
      }
      this.updateSummary();
    }
    updateSummary() {
      if (!this.word) return;
      this.word.setCustomValidity('');
      this.querySelector('[data-character-count]').textContent = Array.from(this.word.value.normalize('NFC')).length + '/13';
      this.querySelector('[data-personalization-summary]').textContent = this.word.value && this.color.value ? this.word.value + ' · ' + this.color.value : '';
    }
    validate() {
      this.sync();
      if (!this.active) return true;
      if (!this.word) return false;
      const text = this.word.value.normalize('NFC');
      this.word.setCustomValidity(!text.trim() || Array.from(text).length > 13 ? this.dataset.error : '');
      return this.word.reportValidity() && this.color.reportValidity();
    }
  });
}
